// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalResetCompany_basic-panel__4cpnL","title":"ModalResetCompany_title__mLuF3","text":"ModalResetCompany_text__kwj+R","item":"ModalResetCompany_item__DrVPV"};